module.exports = __webpack_public_path__ + "media/images/hue-6b6f9347.png";